import React from 'react';
import { Modal, Text, Icon, Button } from '@shopify/polaris';
import { CheckIcon } from '@shopify/polaris-icons';

function FreePlanModal({ isOpen, onClose, onConfirm }) {
  // Style for custom list items with checkmarks
  const listItemStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    // marginBottom: '12px',
  };

  const headerStyle = {
    marginBottom: '16px',
  };

  const sectionStyle = {
    marginBottom: '16px',
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title="Free Plan Details"
      primaryAction={{
        tone: "success",
        content: 'Confirm',
        onAction: () => {
          onConfirm();
          onClose();
        },
      }}
      secondaryActions={{
        content: 'Cancel',
        onAction: onClose,
      }}
      size="medium"
    >
      <Modal.Section>
        <div style={headerStyle}>
          <div style={{ marginBottom: "6px" }}>
            <Text variant="headingMd" as="h3">
              Pay-what-you-use
            </Text>
          </div>
          <Text variant="bodyMd" tone="subdued" as="p">
            3 AI-generated blog posts / month
          </Text>
        </div>

        <div style={sectionStyle}>
          <div style={{ marginBottom: "6px" }}>
            <Text variant="headingSm" as="h4" style={{ marginBottom: "12px" }}>
              What's included:
            </Text>
          </div>

          <div style={listItemStyle}>
            <Icon source={CheckIcon} tone="success" />
            <Text variant="bodyMd">3 AI-generated blog posts / month</Text>
          </div>
          <div style={listItemStyle}>
            <Icon source={CheckIcon} tone="success" />
            <Text variant="bodyMd">Drag-and-drop text editor</Text>
          </div>
          <div style={listItemStyle}>
            <Icon source={CheckIcon} tone="success" />
            <Text variant="bodyMd">Blog post scheduling</Text>
          </div>
          <div style={listItemStyle}>
            <Icon source={CheckIcon} tone="success" />
            <Text variant="bodyMd">Titles and text content included</Text>
          </div>
          <div style={listItemStyle}>
            <Icon source={CheckIcon} tone="success" />
            <Text variant="bodyMd">
              Basic analytics (Sessions & Engagement)
            </Text>
          </div>
        </div>

        <div>
          <Text variant="bodySm" tone="subdued" as="p">
            Perfect for businesses who want to create high-quality blog content
            without monthly commitments.
          </Text>
        </div>
      </Modal.Section>
    </Modal>
  );
}

export default FreePlanModal;
